export default __webpack_public_path__ + "static/media/5_fooddiary__december.90b3eb04.jpg";